var map = {
	"./de.json": 77530,
	"./en.json": 43634,
	"./fr.json": 82681,
	"./pl.json": 625,
	"./preview/de.json": 1479,
	"./preview/en.json": 77279,
	"./preview/fr.json": 81756,
	"./preview/pl.json": 84936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74302;